/* eslint-disable @typescript-eslint/naming-convention, no-underscore-dangle, id-denylist, id-match */

import { Component, Input, Output, EventEmitter, OnDestroy } from '@angular/core';
import { SchemaField, Document, DocumentSchema, SystemFieldType } from 'src/app/modules/core/store/models/document.model';
import { DocumentReader } from 'src/app/modules/core/store/models/document-reader';
import { DynamicField } from '../dynamic-field';
import { ViewComponent } from '../../../store/models/workflow.model';
import { Dataset } from 'src/app/modules/core/store/models/dataset.model';

@Component({
    selector: 'app-array-field',
    templateUrl: './array-field.component.html',
    styleUrls: ['./array-field.component.scss'],
    standalone: false
})
export class ArrayFieldComponent implements DynamicField, OnDestroy {
  @Output() valueChanged = new EventEmitter<DynamicField>();
  @Input() field: SchemaField;
  @Input() displayName: string;
  @Input() layerUId: string;
  @Input() set document(value: Document) {
    this.reader = new DocumentReader(value);
  }
  reader: DocumentReader;

  @Input() viewComponent: ViewComponent;
  @Input() schema: DocumentSchema;
  isReadOnly: boolean;
  @Input() dataset: Dataset;
  selectedValue: string;

  get value(): any {
    return this._value;
  }

  set value(val: any) {
    if (!val) {
      val = [];
    }

    let displayVal = '';

    if (val.length > 0) {
      displayVal = val.join(',');
    }

    this.selectedValue = displayVal || '---';

    this._value = val;
  }

  private _value: any = [];

  showFieldAsEdit: boolean = false;
  private _isEdit: boolean = false;
  @Input() set isEdit(edit: boolean) {
    this._isEdit = edit;

    this.calculateShouldDisplayFieldForEdit();
  }

  calculateShouldDisplayFieldForEdit() {
    // Edit is not yet implemented for this field type
    this.showFieldAsEdit = false; // this._isEdit && !this.isReadOnly;
  }

  constructor() {}

  ngOnDestroy(): void {
    this.valueChanged.complete();
  }

  tpOnContentUpdated(): void {
    const fieldValue = this.reader.getFieldValue(this.field.systemName) || [];
    this.value = [...fieldValue];

    if ((this.field.fieldType & SystemFieldType.Editable) !== SystemFieldType.Editable || this.viewComponent?.configuration?.isReadOnly) {
      this.isReadOnly = true;
      this.calculateShouldDisplayFieldForEdit();
    }
  }

  checkChange(elm: any): void {
    const { checked, value } = elm.srcElement;
    if (checked) {
      if (!this.value.includes(value)) {
        this.value.push(value);
      }
      return;
    } else {
      const idx = this.value.findIndex(v => v === value);
      if (idx >= 0) {
        this.value.splice(idx, 1);
      }
    }

    this.onValueChanged();
  }

  onValueChanged(): void {
    this.valueChanged.emit(this);
  }
}
